module.exports = __webpack_public_path__ + "static/series_830-6352720aa21c5c11162d5f64e99d630c.png";